<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div class="col-md-3 mb-20">
          <div class="form-group">
            <label>Zone:</label>
            <v-select
              class="custom-select-height"
              label="name"
              :options="ZonesList"
              v-model="zone_filter"
            />
          </div>
        </div>

        <!-- STATUT -->
        <div class="col-md-3 mb-3">
          <label>Statut</label>
          <select class="form-control" v-model="status_filter">
            <option value="">Statut (Tous)</option>
            <option :value="0">Nouveau</option>
            <option :value="1">Enregistré</option>
            <option :value="2">Payé</option>
          </select>
        </div>

        <div class="col-md-3 mb-20">
          <div class="form-group">
            <label>Par Date :</label>
            <div class="border p-2 cursor-pointer" @click="showCalendar()">
              {{ selectedDate?.[0]?.format("DD MMM YYYY") || "—" }}
              -
              {{ selectedDate?.[1]?.format("DD MMM YYYY") || "—" }}
              <i class="flaticon-calendar float-end"></i>
            </div>

            <div
              v-show="showCalendarBox"
              class="position-relative mt-2 p-2 bg-white shadow rounded"
              style="z-index: 999"
            >
              <MyDateRangePicker
                v-model="selectedDate"
                @onSelect="showCalendar"
                :enableSecondCalendar="true"
              />
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-3 mt-3" >
          <button class="btn btn-primary me-2" @click="applyFilters">
            <feather-icon icon="FilterIcon" size="16" />
            Filtrer
          </button>

          <button class="btn btn-outline-danger" @click="resetFilters">
            <feather-icon icon="XIcon" size="16" />
            Annuler
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2">
      <!-- Left: per-page + actions -->
      <div class="d-flex align-items-center flex-wrap gap-2">
        <div class="d-flex align-items-center gap-1">
          <label class="mb-0 text-nowrap">Voir</label>
          <v-select
            v-model="users.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block"
            style="min-width: 75px"
            @update:modelValue="getRecords()"
          />
          <label class="mb-0 text-nowrap">sur {{ users.total }} entités</label>
        </div>

        <button
          v-if="auth.can('ADD_BP_Z')"
          @click="AutoAdd"
          class="btn btn-sm btn-success"
        >
          <i class="flaticon-plus me-1"></i>
          Auto-Ajout Bon pour Zone
        </button>

        <router-link
          v-if="auth.can('ADD_BP_Z')"
          class="btn btn-sm btn-primary"
          :to="{ name: 'NewPaymentZonePage' }"
        >
          <i class="flaticon-plus me-1"></i>
          Ajouter Bon pour Zone
        </router-link>
      </div>

      <!-- Right: Search -->
      <div class="position-relative">
        <input
          v-model="users.searchTerm"
          type="text"
          class="form-control form-control-sm rounded-1 ps-4"
          style="min-width: 260px"
          placeholder="Rechercher..."
          @input="handleInput"
        />
        <i
          class="flaticon-search position-absolute top-50 translate-middle-y ms-2"
          style="left: 0; opacity: 0.4; pointer-events: none"
        ></i>
      </div>
    </div>

    <div class="p-15 p-md-20">

    <vue-good-table
      :columns="columns"
      :rows="rows"
      responsive
      :select-options="{
        selectOnCheckboxOnly: true,
        enabled: true,
        clearSelectionText: 'Annuler',
        selectionText: 'Bons Sélectionés',
        disableSelectInfo: true,
      }"
      @selected-rows-change="selectPays"
      @select-all="onSelectAllPays"
    >
      <template #emptystate>
        <center>Aucune entrées correspondants trouvés</center>
      </template>
      <template #table-row="props">
        <span v-if="props.column.field === 'pay_z_ref'" class="text-nowrap">
          <b>{{ props.row.pay_z_ref }}</b>
        </span>

        <span
          v-else-if="props.column.field === 'zone_name'"
          class="text-nowrap"
        >
          {{ props.row.zone_name }}<br />
          {{ props.row.agency_name }}
        </span>

        <span
          v-else-if="props.column.field === 'created_at'"
          class="text-nowrap"
        >
          <template v-if="props.row.created_at != null">
            {{ getDate(props.row.created_at) }}<br />
          </template>
          {{ props.row.by_name }}
        </span>

        <span
          v-else-if="props.column.field === 'paid_time'"
          class="text-nowrap"
        >
          <template v-if="props.row.paid_time != null">
            {{ getDate(props.row.paid_time) }}<br />
          </template>
          {{ props.row.paid_by_name }}
        </span>

        <span v-else-if="props.column.field === 'total'" class="text-nowrap">
          {{ props.row.total }} {{ $devis }}
        </span>

        <template v-else-if="props.column.field === 'statut'">
          <span
            v-if="props.row.statut == 0"
            class="badge rounded-pill fs-13 text-bg-danger"
          >
            Nouveau
          </span>
          <span
            v-else-if="props.row.statut == 1"
            class="badge rounded-pill fs-13 text-bg-info"
          >
            Enregistré
          </span>
          <span
            v-else-if="props.row.statut == 2"
            class="badge rounded-pill fs-13 text-bg-success"
          >
            Payé
          </span>
        </template>
        <template v-else-if="props.column.field === 'action'">
          <div class="dropdown">
            <button
              class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-dots"></i>
            </button>
            <ul class="dropdown-menu">
              <li>
                <router-link
                  class="dropdown-item"
                  :to="{
                    path: `/edit-payment-zone/${props.row.id}/${props.row.pay_z_ref}`,
                  }"
                >
                  <i
                    class="flaticon-view lh-1 me-8 position-relative top-1"
                  ></i>
                  Détails
                </router-link>
              </li>
              <li
                v-if="
                  props.row.statut == 0 &&
                  props.row.num_bns == 0 &&
                  auth.can('BP_Z')
                "
              >
                <button class="dropdown-item" @click="RemoveNote(props.row)">
                  <i
                    class="flaticon-delete lh-1 me-8 position-relative top-1"
                  ></i>
                  Supprimer
                </button>
              </li>
              <li
                v-if="
                  props.row.statut == 0 &&
                  props.row.num_bns != 0 &&
                  auth.can('BP_Z')
                "
              >
                <button class="dropdown-item" @click="SaveBon(props.row)">
                  <i
                    class="flaticon-diskette lh-1 me-8 position-relative top-1"
                  ></i>
                  Enregistrer
                </button>
              </li>
              <li
                v-if="
                  props.row.statut == 1 &&
                  props.row.num_bns != 0 &&
                  auth.can('BP_Z')
                "
              >
                <button class="dropdown-item" @click="OpenBon(props.row)">
                  <i
                    class="flaticon-unlock lh-1 me-8 position-relative top-1"
                  ></i>
                  Ouvrir
                </button>
              </li>
              <li
                v-if="
                  props.row.statut == 1 &&
                  props.row.num_bns != 0 &&
                  auth.can('BP_Z')
                "
              >
                <button class="dropdown-item" @click="BonPaid(props.row)">
                  <i
                    class="flaticon-check lh-1 me-8 position-relative top-1"
                  ></i>
                  Changer En Payé
                </button>
              </li>
            </ul>
          </div>
        </template>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <PaginatorContent :pagination="users" :offset="9" @paginate="getRecords" />
    <div class="row mb-30" v-if="rows && rows.length != 0">
      <div class="col-md-12" style="margin-left: 15px">
        <button class="btn btn-success" @click="SaveNotes">Enregistrer</button>
        <button class="btn btn-info" @click="PaidNotes">Payer</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref, reactive } from "vue";
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import Swal from "sweetalert2";
import { onMounted } from "vue";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";

export default defineComponent({
  components: {
    MyDateRangePicker,
  },
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const isLoader = ref(false);
    const pageLength = ref(10);
    const loading = ref(false);
    const columns = [
      {
        label: "Référence",
        field: "pay_z_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Date de paiement",
        field: "paid_time",
      },
      {
        label: "Zone",
        field: "zone_name",
      },
      {
        label: "Statut",
        field: "statut",
      },
      {
        label: "Bons",
        field: "num_bns",
      },
      {
        label: "Total",
        field: "total",
      },
      {
        label: "Actions",
        field: "action",
        width: "180px",
      },
    ];
    const rows = ref([]);
    const ZonesList = ref([]);
    const zone_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const date_filter = ref("");
    const users = reactive({
      searchTerm: "",
      searchZone: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);
    const row_ref = ref({});
    const pricePaid = ref(0);
    const selectedRows = ref([]);

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    const selectedDate = ref(null);

    const showCalendarBox = ref(false);

    function showCalendar() {
      showCalendarBox.value = !showCalendarBox.value;
    }

    const onSearchZones = async (
      search: string,
      loading: (val: boolean) => void
    ) => {
      if (search.length && ZonesList.value.length === 0) {
        loading(true);
        try {
          const response = await api.get(`/api/auth/ListZone`);
          ZonesList.value = response.data;
          ZonesList.value.unshift({ id: "", name: "Tous" });
        } finally {
          loading(false);
        }
      }
    };

    const getDate = (value: string) => {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    };

    const resolveUserStatusVariant = (status: number) => {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    };

    const convert = (str: string) => {
      const date = new Date(str);
      const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    };

    const applyFilters = () => {
      users.searchZone = zone_filter.value.id;
      users.searchStatut = status_filter.value;
      // Date range
      users.searchSDate = selectedDate.value?.[0]
        ? selectedDate.value[0].format("YYYY-MM-DD")
        : "";

      users.searchEDate = selectedDate.value?.[1]
        ? selectedDate.value[1].format("YYYY-MM-DD")
        : "";
      users.current_page = 1;
      getRecords();
    };

    const resetFilters = () => {
      users.searchZone = "";
      users.searchStatut = "";
      users.searchTerm = "";
      users.searchSDate = "";
      users.searchEDate = "";
      status_filter.value = "";
      date_filter.value = "";
      zone_filter.value = { id: "", name: "" };
      users.current_page = 1;
      selectedDate.value = null;

      // date_filter.value = {};
      getRecords();
    };

    let debounceTimer: any = null;
    const handleInput = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        applyFilters();
      }, 400);
    };

    const getRecords = async (page = 1) => {
      isLoader.value = true;
      try {
        users.current_page = page;
        const response = await api.get(
          `/api/auth/payment_zone_list?searchTerm=${users.searchTerm}&searchZone=${users.searchZone}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&page=${users.current_page}&per_page=${users.per_page}`
        );
        rows.value = response.data.users.data;
        Object.assign(users, response.data.users);
      } finally {
        isLoader.value = false;
      }
    };

    const SaveBon = async (row: any) => {
      const result = await Swal.fire({
        text: "Vous voulez enregistrer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, enregistrer!",
        cancelButtonText: "Annuler",
      });
      if (result.value) {
        try {
          const res = await api.post(`/api/auth/save_bp_zone/${row.id}`);
          if (res.data.message === "success") {
            showToast("Bon est bien enregistré", "success");
            applyFilters();
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas enregistrer ce bon", "error");
          } else {
            showToast("Un erreur ! ", "error");
          }
        } catch {
          showToast("Something went wrong! Pleaz try again", "error");
        }
      }
    };

    const OpenBon = async (row: any) => {
      try {
        const res = await api.post(`/api/auth/unsave_bp_zone/${row.id}`);
        if (res.data.message === "success") {
          showToast("Bon est bien ouvert", "success");
          applyFilters();
        } else if (
          res.data.message === "not exist" ||
          res.data.message === "no parcel"
        ) {
          showToast("Vous pouvez pas transformer ce bon", "error");
        } else {
          showToast;
        }
      } catch {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    };

    const BonPaid = async (row: any) => {
      const data = new FormData();
      data.append("note_ref", row.pay_z_ref);
      data.append("note_id", row.id);
      data.append("user_id", user?.id);
      try {
        const res = await api.post(`/api/auth/Paid_bp_zone`, data);
        if (res.data.message === "success") {
          showToast("Bon est bien payé", "success");
          applyFilters();
        } else if (
          res.data.message === "not exist" ||
          res.data.message === "no parcel"
        ) {
          showToast("Vous pouvez pas transformer ce bon", "error");
        } else {
          showToast("Un erreur ! ", "error");
        }
      } catch {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    };

    async function AutoAdd() {
      try {
        const res = await api.post(`/api/auth/autoadd_bp_zone`);
        if (res.data.msg === "success") {
          showToast("Les bons sont bien ajoutés", "success");
          getRecords();
        } else if (res.data.msg === "empty") {
          showToast("Aucun bon de paiment (Livreur) à ajouter", "error");
        } else if (res.data.msg === "unauthorized") {
          showToast("Vous pouvez pas ajouter des bons", "error");
        } else {
          showToast("Un erreur ! ", "error");
        }
      } catch {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    }

    const RemoveNote = async (row: any) => {
      const result = await Swal.fire({
        text: "Vous voulez supprimer le ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });
      if (result.value) {
        try {
          const res = await api.post(`/api/auth/RemovePayZNote/${row.id}`);
          if (res.data.message === "success") {
            applyFilters();
            showToast("Bon est bien supprimé", "success");
          } else if (res.data.message === "error") {
            showToast("Vous pouvez pas supprimer ce bon", "error");
          }
        } catch {
          showToast("Something went wrong! Pleaz try again", "error");
        }
      }
    };

    const selectPays = (params: any) => {
      selectedRows.value = params.selectedRows;
    };

    const onSelectAllPays = (params: any) => {
      selectedRows.value = params.selectedRows;
    };

    const SaveNotes = async () => {
      const notes: any[] = [];
      if (selectedRows.value.length > 0) {
        selectedRows.value.forEach((row: any) => {
          if (row.statut === 0 && row.num_bns !== 0) {
            notes.push({ id: row.id, ref: row.pay_z_ref });
          }
        });
        const result = await Swal.fire({
          text: "Vous voulez enregistrer ces bons ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, enregistrer!",
          cancelButtonText: "Annuler",
        });
        if (result.value) {
          const data = new FormData();
          data.append("notes", JSON.stringify(notes));
          try {
            const res = await api.post(`/api/auth/save_all_paynote`, data);
            if (res.data === "success") {
              applyFilters();
              showToast("Factures bien enregistrées", "success");
            } else if (res.data === "no note") {
              showToast("Vous pouvez pas les enregistrer", "error");
            }
          } catch {
            showToast("Something went wrong! Pleaz try again", "error");
          }
        }
      }
    };

    const PaidNotes = async () => {
      const notes: any[] = [];
      if (selectedRows.value.length > 0) {
        selectedRows.value.forEach((row: any) => {
          if (row.statut === 1 && row.num_bns !== 0) {
            notes.push({ id: row.id, ref: row.pay_z_ref });
          }
        });
        const result = await Swal.fire({
          text: "Vous voulez payer ces bons ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, payer!",
          cancelButtonText: "Annuler",
        });
        if (result.value) {
          const data = new FormData();
          data.append("notes", JSON.stringify(notes));
          try {
            const res = await api.post(`/api/auth/paid_all_paynote`, data);
            if (res.data === "success") {
              applyFilters();
              showToast("Factures bien enregistrées", "success");
            } else if (res.data === "no note") {
              showToast("Vous pouvez pas les enregistrer", "error");
            }
          } catch {
            showToast("Something went wrong! Please try again", "error");
          }
        }
      }
    };

    onMounted(async () => {
      getRecords();
      try {
        const response = await api.get("/api/auth/ListZone");
        if (response && response.data) {
          ZonesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    });

    return {
      auth,
      user,
      isLoader,
      pageLength,
      loading,
      columns,
      rows,
      ZonesList,
      zone_filter,
      status_filter,
      date_filter,
      users,
      offset,
      row_ref,
      pricePaid,
      selectedRows,
      AutoAdd,
      onSearchZones,
      getDate,
      resolveUserStatusVariant,
      convert,
      applyFilters,
      resetFilters,
      handleInput,
      getRecords,
      SaveBon,
      OpenBon,
      BonPaid,
      RemoveNote,
      selectPays,
      onSelectAllPays,
      SaveNotes,
      PaidNotes,
      selectedDate,
      showCalendarBox,
      showCalendar,
    };
  },
});
</script>
